import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  InputNumber,
  Row,
  Select,
  Table,
  Typography,Empty,ConfigProvider
} from "antd";
import { useNavigate } from "react-router-dom";
import EmptyData from '../Assets/EmptyData.jpg';
const { Title, Text } = Typography;
const { Option } = Select;

const JW_TransportDC = () => {
  const navigate = useNavigate();
  const [data] = useState([
    {
      key: "1",
      material: "Rice",
      issueToday: 380,
      rows: [{ key: 1, gross: 381, tare: 1, net: 380 }],
    },
    {
      key: "2",
      material: "Wheat",
      issueToday: 300,
      rows: [{ key: 1, gross: 301, tare: 1, net: 300 }],
    },
  ]);

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      width: 60,
    },
    {
      title: "Gross (Kg)",
      dataIndex: "gross",
      render: (val) => <InputNumber value={val} style={{ width: "100%" }} />,
    },
    {
      title: "Tare (Kg)",
      dataIndex: "tare",
      render: (val) => <InputNumber value={val} style={{ width: "100%" }} />,
    },
    {
      title: "Net (Kg)",
      dataIndex: "net",
      render: (val) => <InputNumber value={val} style={{ width: "100%" }} />,
    },
  ];

  return (
    <Card style={{ margin: 24 }}>
      {/* Header Section */}
      <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
        <Col>
          <Text strong style={{ fontSize: 16 }}>
            Delivery Challan — Jobwork Issue
          </Text>
          <br />
          <Text
            type="secondary"
            style={{
              fontSize: 12,
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
              padding: "2px 6px",
              display: "inline-block",
              marginTop: 4,
            }}
          >
            MSPC: KARWAR • Month: Aug 2025 • PO: JWPO-202508-123
          </Text>
        </Col>
        <Col>
          <span style={{ fontWeight: 400 }}>MSPC: </span>
          <Select defaultValue="KARWAR" style={{ width: 120, marginRight: 10 }}>
            <Option value="KARWAR">KARWAR</Option>
          </Select>
          <span style={{ fontWeight: 400 }}>Month: </span>
          <Select defaultValue="Aug 2025" style={{ width: 120, marginRight: 10 }}>
            <Option value="Aug 2025">Aug 2025</Option>
          </Select>
          <Button style={{ marginRight: 8 }}>Load POs</Button>
          <Button style={{ marginRight: 8 }}>Load Draft</Button>
          <Button type="default">Save Draft</Button>
        </Col>
      </Row>

      <Divider />

      {/* Step Tabs */}
      <Row gutter={8} justify="space-between" style={{ marginBottom: 16 }}>
        <Col>
          <Button disabled>1. Select PO & RM</Button>
        </Col>
        <Col>
          <Button type="primary">2. Pack & Weigh (Bags)</Button>
        </Col>
        <Col>
          <Button disabled>3. Transport</Button>
        </Col>
        <Col>
          <Button disabled>4. Review & Generate</Button>
        </Col>
      </Row>

      <Divider />

     <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
  <Col>
    <Title level={5}>Step 2 — Pack & Weigh (Bagization)</Title>
  </Col>
  <Col>
    <Form.Item
      label="Default Tare per Bags (Kg)"
      style={{ marginBottom: 0 }}
    >
      <InputNumber defaultValue={0.10} style={{ width: 100 }} />
    </Form.Item>
  </Col>
</Row>


      {data.map((item) => (
        <Card
          key={item.key}
          style={{ marginTop: 20 }}
          title={
            <Row justify="space-between" align="middle">
              <Text strong>{item.material}</Text>
              <Form layout="inline">
                <Form.Item label="Issue Today">
                  <InputNumber value={item.issueToday} style={{ width: 100 }} />
                </Form.Item>
                <Form.Item label="Bags">
                  <InputNumber value={1} style={{ width: 80 }} />
                </Form.Item>
                <Form.Item label="Tare/Bag (Kg)">
                  <InputNumber value={1} style={{ width: 100 }} />
                </Form.Item>
                <Form.Item>
                  <Button size="small">Generate Bags</Button>
                </Form.Item>
                <Form.Item>
                  <Button size="small">Even Split</Button>
                </Form.Item>
              </Form>
            </Row>
          }
        >
          <ConfigProvider
                        renderEmpty={() => (
                          <Empty
                            image={EmptyData}
                            description="No CategoryMaster Data Available"
                            imageStyle={{ height: 200 }}
                          />
                        )}
                      >
          <Table
            pagination={false}
            columns={columns}
            dataSource={item.rows}
        summary={() => (
  <Table.Summary.Row>
  <Table.Summary.Cell
    index={0}
    colSpan={1}   // must match FG Name column span
    align="left"  // keep left so it follows FG Name
    style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
  >
    <strong>Total</strong>
  </Table.Summary.Cell>
  <Table.Summary.Cell index={1} align="right">
    <Text strong>{item.rows[0].gross}</Text>
  </Table.Summary.Cell>
  <Table.Summary.Cell index={2} align="right">
    <Text strong>{item.rows[0].tare}</Text>
  </Table.Summary.Cell>
  <Table.Summary.Cell index={3} align="right">
    <Text strong>{item.rows[0].net}</Text>
  </Table.Summary.Cell>
</Table.Summary.Row>

)}


          />
          </ConfigProvider>
          <Text style={{ fontSize: 12, display: "block", marginTop: 6 }}>
            Net should equal Issue Today. Tolerance ±0.25 Kg is acceptable;
            larger differences are flagged.
          </Text>
        </Card>
      ))}

      {/* Footer Button */}
      <Row justify="end" style={{ marginTop: 24 }}>
        <Button
          type="primary"
          onClick={() => navigate("/jobwork/jobwork_dc/jw_gendc")}
        >
          Next Transport
        </Button>
      </Row>
    </Card>
  );
};

export default JW_TransportDC;
